import ImportantNoticesMobile from './ImportantNoticesMobile'
import ImportantNoticesDesktop from './ImportantNoticesDesktop'

const ImportantNoticesExpand = () => {
  return (
    <>
      {/* Mobile Modal Version */}
      <div className="d-block d-lg-none">
        <ImportantNoticesMobile />
      </div>

      {/* Desktop Expand Version */}
      <div className="d-none d-lg-block">
        <ImportantNoticesDesktop />
      </div>
    </>
  )
}
export default ImportantNoticesExpand
